<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
     
      row-key="OrderId"
      ref="list"
      unit="销售订单执行表"
      :show-summary="true"
      :expand-all-row="true"
      :page="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.orderProductList"
      urlHash='business/sales/saleorderxecution'
      :queryParamsAppend="{}"
      :is-dialog-query="isDialogQuery"
      isShowText
      :showTextArr="showTextArr"
     
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onPrint">打印</el-button>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/sales/saleorderxecution/list.json";
import tableParam from "@/data/business/sales/saleorderxecution/query.json";
import Bus from "@/utils/bus";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    //是否弹窗查询
    isDialogQuery: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/sa/saOrder").default,
      showTextArr: [
        {
          type: "time",
          label: "单据时间",
          startKey: "DocDateStart",
          endKey: "DocDateEnd",
        },
        {
          type: "data",
          label: "客户",
          key: "TradeUnitName",
        },
        {
          type: "data",
          label: "存货",
          key: "ProductName",
        },
      ],
      params: {
      
      },
    };
  },
  activated() {
    if (this.$refs.list.isSetQuery === false) {
      this.getData();
    }
  },
  mounted() {
    if (!this.$permission.canPrice("/business/sales/saleorderxecution")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "TaxPrice");
      list.tableList.splice(findIndex, 1);
      const findIndex1 = list.tableList.findIndex(item => item.tableName == "SalePrice");
      list.tableList.splice(findIndex1, 1);
      const findIndex3 = list.tableList.findIndex(item => item.tableName == "SaDocAmount");
      list.tableList.splice(findIndex3, 1);
      const findIndex4 = list.tableList.findIndex(item => item.tableName == "UnSaDocAmount");
      list.tableList.splice(findIndex4, 1);
      const findIndex5 = list.tableList.findIndex(item => item.tableName == "ReceiptAmount");
      list.tableList.splice(findIndex5, 1);
      const findIndex6 = list.tableList.findIndex(item => item.tableName == "UnSaDocReceiptAmount");
      list.tableList.splice(findIndex6, 1);
      const findIndex7 = list.tableList.findIndex(item => item.tableName == "UnReceiptAmount");
      list.tableList.splice(findIndex7, 1);
      const findIndex8 = list.tableList.findIndex(item => item.tableName == "InvoiceAmount");
      list.tableList.splice(findIndex8, 1);
      const findIndex9 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      list.tableList.splice(findIndex9, 1);
      const findIndex10 = list.tableList.findIndex(item => item.tableName == "UnInvoiceAmount");
      list.tableList.splice(findIndex10, 1);
    }
    Bus.$on("closeTag", (route) => {
      console.log("route.fullPath 销售订单执行表", route.fullPath);
      console.log("this.$route.fullPath 销售订单执行表", this.$route.fullPath);

      if (route.fullPath === "/business/sales/saleorderxecution") {
        this.$refs.list.data = [];
        this.$refs.list.isSetQuery = false;
      }
    });
  },
  methods: {
    closed(isSetQuery) {
      if (!isSetQuery) {
        this.closeSelectedTag(this.$route);
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "index") {
          // to reload home page
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    getDateFunc(){
      return new Promise(resolve=>{
          this.api.list({'Code':'ProcessStage'}).then(res=>{
            resolve({Data:res.Data,Count:res.Count,Code:res.Code})
          })
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onPrint() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var data = {
        Params: params,
        TableNames: list.tableList,
        ParamsData: list.paramsData,
      };
      sessionStorage.setItem("saleorderxecution_print", JSON.stringify(data));

      var origin = location.origin;
      window.open(origin + "/#/business/sales/saleorderxecution/print");
    },
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.saOrderExecutionExport(params).then((res) => {
        loading.close();
      });
    },
  
  },
};
</script>